import getOr from "lodash/fp/getOr";
import classNames from "classnames";
import { getPriceText } from "../../../../../../utils/currency";
import { Product } from "../../../../../../models/Product";
import { isMobileByWidth } from "../../../../../../utils/utils";
import { DComponent } from "../../../../../../components/DComponent";
import { LocalStorage } from "../../../../../../models/LocalStorage";
import { MINI_APP } from "../../../../../../utils/miniApp";
import { EVENTS, listenEvent, removeEvent } from "../../../../../../utils/event";
// eslint-disable-next-line no-unused-vars
import { PriceSaving } from "../../../../../../models/PriceSaving";
import LowestTag from "../LowestTag";

export default class ProductItem extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    hideSelect,
    isSelected = true,
    isLast = false,
    cartId,
    product = new Product(),
    onSelect = () => { },
    onChange = () => { },
  } = {}) {
    let originPriceText = product.meta?.originPrice && product.sitePriceCur && product.meta?.originPrice > product.sitePrice ? getPriceText(product.meta.originPrice, product.sitePriceCur) : "";
    super(arguments[0], parent, id, {
      class: classNames("ProductItem", {
        "is-rfq": product.type === Product.TYPE_PRODUCT.RFQ.id,
        "hide-select": hideSelect,
        "hide-color": !product?.meta?.color,
        "hide-size": !product?.meta?.size,
        "hide-site-price": !(product?.sitePrice && product?.sitePriceCur),
        "is-last": isLast,
        "has-origin-price": originPriceText,
      }),
      image: getOr("", "meta.image")(product) || (LocalStorage.getLanguage() === "vi" ? require("../../../../../../assets/images/checkout/pimg_default_vi.jpg") : require("../../../../../../assets/images/checkout/pimg_default_en.jpg")),
      checked: isSelected ? "checked" : "",
      currentUrl: getOr("", "meta.currentUrl")(product) || product.siteUrl,
      title: product?.meta?.title,
      color: product?.meta?.color,
      size: product?.meta?.size,
      sitePrice: getPriceText(product.sitePrice, product.sitePriceCur),
      quantity: product.quantity,
      currentPrice: getPriceText(product.price, product.currentCurrency),
      originPrice: originPriceText,
    }, true, defaultLoading);
    this.cartId = cartId;
    this.product = product;
    this.onSelect = onSelect;
    this.onChange = onChange;
    this.maxQuantity = 9999;
    /** @type {LowestTag} */
    this.lowestTag = undefined;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "ProductItem");
  }

  loadHtml() {
    return isMobileByWidth() ? require("html-loader!./itemMobile.html") : require("html-loader!./item.html");
  }

  after() {
    this.lowestTag = new LowestTag({ parent: $(".lowest-price", this.element) })
    this.setNote();
    this.addEventListener();
  }

  addEventListener() {
    $("input[name=checkProduct]", this.element).on("change", (e) => {
      this.setSelected(e.target.checked);
      typeof this.onSelect == "function" && this.onSelect(this.element);
    })

    $(".btn-remove", this.element).on("click", () => {
      this.product.quantity = 0;
      typeof this.onChange == "function" && this.onChange(this.product);
    });

    $(".quantity .sub-btn", this.element).on("click", () => {
      let quantity = this.getQuantity();
      if (quantity > 1) {
        this.setQuantity(quantity - 1);
      } else {
        this.product.quantity = 0;
      }
      typeof this.onChange == "function" && this.onChange(this.product);
    });

    $(".quantity .plus-btn", this.element).on("click", () => {
      let quantity = this.getQuantity();
      if (quantity < this.maxQuantity) {
        this.setQuantity(quantity + 1);
        typeof this.onChange == "function" && this.onChange(this.product);
      }
    });

    $(".quantity input[name=quantity]", this.element).on("input", (e) => {
      let quantity = $(e.currentTarget).val().slice(0, 4);
      if (!quantity || parseInt(quantity) === 0 || $(e.currentTarget).val() > this.maxQuantity) {
        $(e.currentTarget).parent().addClass("error");
        if ($(e.currentTarget).val() > this.maxQuantity) {
          this.element.addClass("show-limit");
        } else {
          this.element.removeClass("show-limit");
        }
      } else {
        this.element.removeClass("show-limit");
        $(e.currentTarget).parent().removeClass("error");
      }
    });

    $(".quantity input[name=quantity]", this.element).on("focusout", (e) => {
      let quantity = $(e.currentTarget).val().slice(0, 4);
      if (!quantity || parseInt(quantity) === 0 || $(e.currentTarget).val() > this.maxQuantity) {
        this.element.removeClass("show-limit");
        $(e.currentTarget).parent().removeClass("error");
        const value = $(e.currentTarget).attr("value");
        this.setQuantity(value);
      } else {
        let productQuantity = parseInt(this.product.quantity || 0);
        if (parseInt(quantity) !== productQuantity) {
          this.setQuantity(quantity);
          typeof this.onChange == "function" && this.onChange(this.product);
        }
      }
    });

    if (LocalStorage.isMiniApp()) {
      $(".detail a", this.element).on("click", (e) => {
        e.preventDefault();
        MINI_APP.openSite({
          url: $(e.currentTarget).attr("href"),
        })
      });

    }
    removeEvent(EVENTS.UPDATE_PRICE_TAGS + this.product.id);
    listenEvent(EVENTS.UPDATE_PRICE_TAGS + this.product.id, ({ product = {}, tags = [] }) => this.setPriceTags(product, tags));

    removeEvent(EVENTS.UPDATE_PRICE_SAVINGS + this.product.id);
    listenEvent(EVENTS.UPDATE_PRICE_SAVINGS + this.product.id, ({ product = {}, saving }) => this.setPrice(product, saving));
  }


  setPriceTags(product = {}, tags = []) {
    if (product.id !== this.product.id) return;
    this.setLowestPrice(tags.length > 0);
    this.lowestTag.setPriceTags(tags);
  }

  setLowestPrice(isLowestPrice = false) {
    this.element.toggleClass("is-lowest-price", isLowestPrice);
  }

  setNote() {
    let noteOOS = this.product.getNoteType(Product.TYPE_NOTES.OOS), noteMaxQuantity = this.product.getNoteType(Product.TYPE_NOTES.MAX_QUANTITY);
    if (noteOOS) {
      $(".warning", this.element).text(noteOOS.text || $.i18n("checkout_itemOOS")).attr("type", Product.TYPE_NOTES.OOS);
    } else if (noteMaxQuantity) {
      $(".warning", this.element).text(noteMaxQuantity.text || $.i18n("checkout_itemLimit")).attr("type", Product.TYPE_NOTES.MAX_QUANTITY);
    } else {
      $(".warning", this.element).text("").attr("type", "");
    }
    this.maxQuantity = noteMaxQuantity?.value || this.maxQuantity;
  }

  /**
   * 
   * @param {Product} product 
   * @param {PriceSaving} saving 
   */
  setPrice(product, saving) {
    if (product.id !== this.product.id || !saving?.savingAmount) {
      this.element.removeClass("drop-price");
      return;
    }

    let dropPrice = getPriceText(saving.prevUnitPrice - saving.unitPrice, saving.cur);
    let sitePrice = getPriceText(saving.prevUnitPrice, saving.cur);
    $(".drop-price .value", this.element).html($.i18n("checkout_dropsPrice", dropPrice, sitePrice));
    this.element.addClass("drop-price");
  }

  getQuantity() {
    return $("input[name=quantity]", this.element).val() * 1;
  }

  setQuantity(value) {
    this.product.quantity = value;
    $("input[name=quantity]", this.element).val(value);
    $("input[name=quantity]", this.element).attr("value", value);
  }

  getSelected() {
    return $("input[name=checkProduct]", this.element).is(':checked');
  }

  setSelected(isChecked) {
    $("input[name=checkProduct]", this.element).prop('checked', isChecked);
  }
}